import { recoverConfigSchema } from "@redotech/redo-marketing-templates-common/recover-config";
import * as z from "zod";

export const getRecoverConfigById = {
  name: "getRecoverConfigById" as const,
  input: z.object({ id: z.string() }),
  output: recoverConfigSchema,
};
